import React, { useContext, useEffect, useState } from "react";
import { FarmerContext } from "./FarmerContext";
import { Link,Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';
export default function FarmerDashboard(){ 
  const styles=`
  @media(min-width:1px) and (max-width:1200px){
  .landing-page{
     font-size: 1.125rem /* 18px */;
      line-height: 1.75rem ;
  }
  }
  @media(min-width:601px) and (max-width:900px){
  .landing-page{
      font-size: 1rem /* 16px */;
        line-height: 1.5rem /* 24px */;
  }
  }
  
  @media(min-width:401px) and (max-width:600px){
  .landing-page{
    font-size: 0.875rem /* 14px */;
        line-height: 1.25rem;
  }
  }
  
  @media(min-width:0px) and (max-width:400px){
  .landing-page{
         font-size: 0.75rem /* 12px */;
        line-height: 1rem /* 16px */;
  }
  }
`
const styleSheet=document.createElement("style")
styleSheet.type="text/css";
styleSheet.innerText=styles
document.head.appendChild(styleSheet)
  // Token in which a user has
    const {farmersData}=useContext(FarmerContext) 
    const [dropdownVisible,setDropdownVisible]=useState(false)
    return (
        <div className="bg-gray-100  flex flex-col landing-page mt-20">
          <div className="relative"
                    onMouseEnter={() => setDropdownVisible(true)}
                    onMouseLeave={() => setDropdownVisible(false)}>
            <Link className=" hover:text-blue-500 flex flex-col"  to="account">
              {farmersData?.profile ? <img src={farmersData?.profile} alt="Profile" className=" h-20 w-20 rounded-full"/>:<FontAwesomeIcon icon={faUser} className="w-16 h-16 rounded-full"/>}
            </Link>
           
            {dropdownVisible && 
               <div className="top-20 left-0 bg-white shadow-lg rounded-md p-4 w-40  gap-x-6">
                 <Link to="account/change" className="block text-gray-700 hover:text-blue-500 mb-2">
                    <FontAwesomeIcon icon={faTachometerAlt}/>Account
                 </Link>

                 <Link to="account/logout" className="block text-gray-700 hover:text-blue-500 mb-2">
                    <FontAwesomeIcon icon={faSignOut}/>Logout
                 </Link>
               </div>
            }

            </div>
            <p className="text-blue-500 italic">Welcome {farmersData?.FarmerContextusername}</p>
            {/* {farmersData?.profile?<img src={farmersData?.profile} className=" h-20 w-20 rounded-full"/>:<FontAwesomeIcon icon={faUser} className=" w-12 h-12 rounded-full"/>} */}
             <div className="space-x-3 max-w-full min-w-fit ">
              <Link to="banks" className="hover:text-blue-500">Banks</Link>
              <Link to="customers" className="hover:text-blue-500">Customers</Link>
              <Link to="hotels" className="hover:text-blue-500">Hotels</Link>
              <Link to="transporters" className="hover:text-blue-500">Transporters</Link>
              <Link to="communicate" className="hover:text-blue-500">Communicate</Link>
              <Outlet/>
            </div>

        </div>
    );
    
}
